import { Component, EnvironmentInjector, HostListener, OnInit, Injectable, ViewChild, ElementRef, runInInjectionContext, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LoginService } from "../../Services/login.service";
import {
  AngularFireDatabase,
  AngularFireList,
} from "@angular/fire/compat/database";
import { MatDialog } from "@angular/material/dialog";
import { ScreencastActionModelComponent } from "src/app/screencast/screencast-action-model/screencast-action-model.component";
import { ProjectService } from "src/app/Services/project.service";
import { Observable, Subscription } from "rxjs";
import { SharedService } from "src/app/Services/sharedService";
import { DatePipe, ViewportScroller } from "@angular/common";
import moment from "moment";
import * as M from "materialize-css/dist/js/materialize";

declare var $;
import { trigger, transition, query, style, animate, group } from '@angular/animations';
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import { CustomTimeAgoPipe } from '../../time-ago.pipe';
import { MatSnackBar } from "@angular/material/snack-bar";
import { sysConfig } from "./../../sysConfig";
import {
  installerConfirmCopy,
  resolveEmployeeFirstName,
  isInstallerFirstTimeEmployee,
} from "src/app/utils/installer-confirm-copy.util";
import { isRustAgentUser } from "src/app/agent-deploy/agent-deploy.config";
import { NewPasswordComponent } from "src/app/new-password/new-password.component";
import { PasswordResetsDialogComponent } from "src/app/components/password-resets-dialog/password-resets-dialog.component";
import { ConfirmationDialogComponent } from "src/app/confirmation-dialog/confirmation-dialog.component";
import { SweetAlertService } from 'src/app/Services/sweet-alert.service';
import { CreateUserComponent } from "../create-user/create-user.component";
import { ModalService } from "src/app/Services/modal.service";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { environment } from "src/environments/environment";
import { getSignedOutLabelForUser, getPasswordResetLabelForUser } from "src/app/utils/employee-status.util";
import { AdminControlConfirmDialogComponent } from "../create-user/admin-control-confirm-dialog/admin-control-confirm-dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { colors } from "src/app/colors";
import { EntitlementsService } from "src/app/Services/entitlements.service";
import { EntitlementKey } from "src/app/entitlements/entitlement-keys";
import {
  getSoftwareTypeOptions,
  SoftwareTypeOption,
  SoftwareVersionType,
  validateSoftwareVersionType,
} from "src/app/entitlements/plan-software-type.util";
import { PlanUpgradeDialogComponent } from "src/app/components/plan-upgrade-dialog/plan-upgrade-dialog.component";
import { processTimelineSessionLogs } from "src/app/utils/timeline-session-logs.util";

const left = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(-100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(100%)' }))], {
      optional: true,
    }),
  ]),
];

const right = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(-100%)' }))], {
      optional: true,
    }),
  ]),
];

class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
  status: string;
  time: string;
  isreceive: boolean;
}
@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.css"],
  providers: [DatePipe],
  animations: [
    trigger('animSlider', [
      transition(':increment', right),
      transition(':decrement', left),
    ]),
  ],
  standalone: false
})
export class TabsComponent implements OnInit {
  @ViewChild('userModal') modalRef: ElementRef<HTMLInputElement>;
  userDataSubscription: Subscription;
  stackedArr: any = [];
  isScreenCast = false;
  pieChartAllData: any;
  endDate: any = new Date();
  endDateForWebUsageChart: any = new Date();
  startDate;
  startDateForWebUsageChart: any;
  ismodelOpen = false;
  userId: any;
  userDetails: any;
  screenShareImage =
    "https://images.unsplash.com/photo-1508138221679-760a23a2285b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80";
  loading = false;
  screenCastImage: string;
  selectedTab = "Application Usages";
  screenCastRequestStatus: boolean = false;
  receivedData: string;
  private dbPath: string | null = null;
  usersRef: AngularFireList<User> = null;
  stackedChartData: any;
  selectedTabIndex;
  /** Same semantics as `allUserList[i].status` in user-list (string, moment, etc.). */
  status: any;
  /** True after first getUserData emission for this profile (or when presence cannot load). */
  presenceResolved = false;
  agentIntegrity: any = null;
  showHealthTooltipCard: boolean = false;
  healthTooltipPosition: { top: number; left: number } = { top: 0, left: 0 };
  healthTooltipHovered: boolean = false;
  private healthTooltipTimeout: any = null;
  /** Raw Firebase `idleStartTime` when status is idle (matches user-list row). */
  idleStartTimeRaw: any = null;
  /** Raw Firebase `lastOnlineAtTz` for offline tooltips (UTC). */
  lastOnlineAtTzRaw: any = null;
  /** Raw Firebase `lastOnlineAt` fallback when Tz field is absent. */
  lastOnlineAtRaw: any = null;
  donutChartData: any;
  totalWorkingHours: any;
  lastActiveTime: any;
  lastActiveTimeTz: any = null;
  sendingStartDate: any = null;
  sendingEndDate: any = null;
  x_min: number;
  stackedChartlabel: any[];
  sessionData: any;
  barChartLabels: any;
  pieChartData: any[];
  pieChartLabel: any[];
  pieChartDisplayData: any[];
  tempDataTooltip: any = []
  newSessionTimeline: any = [];
  barData = [];
  x_max: number;
  currentDate: any = moment();
  _isAppUsageLoading = true;
  _isWebSiteUsageLoading = true;
  _isUsageLoading: boolean = true;
  _isStackbarLoading: boolean = true;
  currentDateOfWeek = new Date();
  currentDateOfStart;
  currentDateofEnd;
  currentWeekDisplay;
  currentWeekArray = [];
  sysConfig = sysConfig

  get showRustAgentBetaBadge(): boolean {
    if (!sysConfig.rustAgentBetaBadgeEnabled) {
      return false;
    }
    return (
      isRustAgentUser(this.userDetails) ||
      isRustAgentUser({ appInfo: this.currentApplicationInformation })
    );
  }

  stackcurrentDateOfWeek = new Date();
  stackcurrentDateOfStart;
  stackcurrentDateofEnd;
  stackcurrentWeekDisplay;
  stackcurrentWeekArray = [];
  appUsageColor = ['#ff6f61', // Red
    '#ffcc5c', // Gold
    '#ffa07a', // Light Salmon
    '#ffeb99', // Pale Goldenrod
    '#98fb98', // Pale Green
    '#00ced1', // Dark Turquoise
    '#87ceeb', // Sky Blue
    '#6495ed', // Cornflower Blue
    '#9370db', // Medium Purple
    '#c71585', // Medium Violet Red
  ]
  workingHours: any;
  userImageClass = 'profile-avatar-img';
  isBtnDisabled = '';
  logoutReason: any;
  isConductIntegrated = false;
  isImportingConductTimelogs = false;
  conductTimelogs: any[] = [];
  totalConductWorkedHours: string = '00:00:00';
  conductSelectedDate: moment.Moment = moment();
  conductDateModel: Date = moment().toDate();

  onConductPreviousDate(): void {
    this.conductSelectedDate = this.conductSelectedDate.clone().subtract(1, 'day');
    this.conductDateModel = this.conductSelectedDate.toDate();
    this.loadConductTimelogs();
  }

  onConductNextDate(): void {
    this.conductSelectedDate = this.conductSelectedDate.clone().add(1, 'day');
    this.conductDateModel = this.conductSelectedDate.toDate();
    this.loadConductTimelogs();
  }

  onConductDatePicked(pickedDate: any): void {
    if (pickedDate) {
      this.conductSelectedDate = moment(pickedDate);
      this.conductDateModel = this.conductSelectedDate.toDate();
      this.loadConductTimelogs();
    }
  }
  isAdmin: boolean;
  isManager: boolean;
  isTeamLead: boolean;
  globalSettings: any;
  menuItems: any = [
    { roles: ['isAdmin'], label: 'Edit Profile', icon: 'edit', isSvg: false, action: () => this.openModalFire(this.userId), isSubmenu: false },
    { roles: ['isAdmin', 'isManager', 'isTeamLead'], label: 'Timesheet', icon: 'summarize', isSvg: false, action: () => this.navigateToTimeSheet(), isSubmenu: false },
    { roles: ['isAdmin'], label: 'Reset Password', icon: 'lock_reset', isSvg: false, action: () => this.resetPassword(this.userDetails), isSubmenu: false },
    { roles: ['isAdmin'], label: 'Password reset history', icon: 'history', isSvg: false, action: () => this.openPasswordResets(this.userDetails), isSubmenu: false },
    { roles: ['isAdmin', 'isManager'], label: 'Settings', icon: 'settings', isSvg: false, id: 'userSettings', action: () => this.navigateToSettings(), isSubmenu: false },
    {
      roles: ['isAdmin', 'isManager', 'isTeamLead'], label: 'Agent Info', icon: 'info', isSvg: false, action: () => { }, id: 'appInfo', isSubmenu: true, submenu: {
        menus: [
          {
            value: 'N/A',
            icon: 'release_alert',
            tooltip: 'Version'
          },
          // { // HERE IS DUMMY DATA WHAT WE SHOW IN MENUS
          //   value: 'v-4.2.1',
          //   icon: 'release_alert',
          //   tooltip: 'Version'
          // },
          // {
          //   value: 'Hidden',
          //   icon: 'visibility_off',
          //   tooltip: 'Mode'
          // },
          // {
          //   value: 'Ubuntu',
          //   icon: 'https://us.aptabase.com/assets/ubuntu-9a344cb4.svg',
          //   image: true,
          //   tooltip: 'OS'
          // }
        ]
      }
    },
    { roles: ['isAdmin'], label: 'Delete', icon: 'delete', isSvg: false, action: () => this.deleteUser(this.userId, this.userDetails), class: 'delete', isSubmenu: false },
  ];
  maxApplicationUsageDate: any = new Date().toISOString();
  maxWebsiteUsageDate: any = new Date().toISOString();
  minApplicationUsageDate: any = new Date().toISOString();
  minWebsiteUsageDate: any = new Date().toISOString();
  minDateForTimeLine: any = new Date().toISOString();
  maxDateForTimeLine: any = new Date().toISOString();

  selfControlTooltip: string = 'Employees can start or stop tracking themselves and see their own activity details.';
  invisibleTrackingTooltip: string = 'Work activity is tracked automatically in the background, without any action or visible indication to employees.';
  adminControlTooltip: string = 'The company manages tracking. Employees can see their activity, but can’t control tracking.';
  checkIsPersonalize: boolean = false;
  generalDownloads = [
    { label: 'Windows 7 & 8', link: './../../../assets/Windows/General/Supersee_Installer.bat' },
    { label: 'Linux', link: environment.app.linuxInstallerUrl },
    { label: 'Mac', link: environment.app.macInstallerUrl }
  ];

  silentDownloads = [
    { label: 'Windows 7 & 8' },
    { label: 'Linux' },
    { label: 'Mac' }
  ];
  currentApplicationInformation: any;
  currentOSInformation: any;
  softwareTypeOptions: SoftwareTypeOption[] = [];
  private entitlementsSub?: Subscription;

  constructor(
    private _route: ActivatedRoute,
    private _loginService: LoginService,
    private db: AngularFireDatabase,
    public dialog: MatDialog,
    private _projectService: ProjectService,
    public _sharedService: SharedService,
    private _router: Router,
    private datePipe: DatePipe,
    private _messagingService: MessagingServiceService,
    private customtimeAgoPipe: CustomTimeAgoPipe,
    private _snackBar: MatSnackBar,
    private scroller: ViewportScroller,
    private _modalService: ModalService,
    private sweetAlertService: SweetAlertService,
    private tokenEncryptionService: TokenEncryptionService,
    private sanitizer: DomSanitizer,
    private injector: EnvironmentInjector,
    private entitlementsService: EntitlementsService,
    private cdr: ChangeDetectorRef
  ) {
    if (document.getElementById('TooltipId')) {
      var existingTooltip = document.getElementById('TooltipId');
      existingTooltip.parentNode.removeChild(existingTooltip);
    }

    // Listen for dbPath updates
    this._projectService.isFirebaseRefresh.subscribe((newDbPath: any) => {
      if (newDbPath && newDbPath.data) {
        this.dbPath = newDbPath.data;
        console.log('Tabs: dbPath updated to:', this.dbPath);
      }
    });

    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
    this.globalSettings = this.tokenEncryptionService.getEncryptedItem<any>('globalSettings');

    _messagingService.showNotification();

    this.startDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 7
    );

    this.startDateForWebUsageChart = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 7
    );

    document.getElementById("pieChartContainer")
      ? document.getElementById("pieChartContainer").remove()
      : "";
    document.getElementById("chartContainer")
      ? document.getElementById("chartContainer").remove()
      : "";

    document.getElementById("donutChartNewContainer")
      ? document.getElementById("donutChartNewContainer").remove()
      : "";

    document.getElementById("donutChartNewContainer")
      ? document.getElementById("donutChartNewContainer").remove()
      : "";

    this._projectService.screencastRequest.subscribe((value) => {
      this.dialog.closeAll();
      this.ismodelOpen = value;
      if (value == false) {
        this.screenCastRequestStatus = false;
        this._loginService.requestScreenCastOff({ user: this.userId });
        this.db.database
          .ref(`${this.dbPath}`)
          .child(`${this.userId}`)
          .update({ scRequestStop: true });
        this.screenCastImage = null;
        this.isScreenCast = false;
      }
    });

    this.selectedTabIndex = 0;
    this._route.params.subscribe((params) => {
      if (!this.userId) {
        this.userId = params.userId;
        this.getstatus();
        this.loadConductTimelogs();
      } else {
        if (this.userId != params.userId) {
          this.startDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate() - 7
          );
          this.userId = params.userId;
          this.getstatus();
          this.ngOnInit();
          // 🔹 FIX: Reload all chart data when user changes via search
          this.loadProfileData();
          // Clear any visible tooltips when switching profiles
          this.clearAllTooltips();
        } else {
          this.userId = params.userId;
          this.getstatus();
          this.loadConductTimelogs();
        }
      }
    });

    $(document).ready(function () {
      $(".tooltipped").tooltip();
    });

  }

  ngOnInit() {
    this.loading = true;
    this.entitlementsService.syncFromSession();
    this.refreshDownloadSoftwareTypeOptions();
    this.entitlementsSub = this.entitlementsService.stateChanged$.subscribe(() => {
      this.refreshDownloadSoftwareTypeOptions();
    });
    this.getUserDetails();
    // Clear any existing tooltips when component initializes
    this.clearAllTooltips();
    this.setTimeRangeForDateInputs();
    // Load chart/week state in OnInit so week labels are set before the first CD pass.
    // Running this in AfterViewInit caused NG0100 (currentWeekDisplay went undefined → date string).
    this.loadProfileData();
  }

  private loadProfileData(): void {
    const formattedStartDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    const formattedEndDate = this.datePipe.transform(this.endDate, "yyyy-MM-dd");
    const formattedStartWebUsage = this.datePipe.transform(this.startDateForWebUsageChart, "yyyy-MM-dd");
    const formattedEndWebUsage = this.datePipe.transform(this.endDateForWebUsageChart, "yyyy-MM-dd");

    this.getPieChartData(formattedStartDate, formattedEndDate);
    this.getChartDataWebsiteUsage(formattedStartWebUsage, formattedEndWebUsage);

    this.getWeek(0);
    this.updateWeekText('Timeline');
    this.updateWeekText('Statistics');
    this.loadConductTimelogs();
  }

  loadConductTimelogs(): void {
    const targetUserId = this.userId || (this._route && this._route.snapshot && this._route.snapshot.params ? this._route.snapshot.params['userId'] : null);
    if (!targetUserId) return;
    this.userId = targetUserId;
    this.isImportingConductTimelogs = true;

    const user = this.tokenEncryptionService?.getEncryptedItem<any>('user') || JSON.parse(localStorage.getItem('currentUser') || '{}');
    const companyId = user?.company_id || user?.companyId || user?.id || user?.userId || '';

    this._projectService.getConductIntegrationStatus(companyId).subscribe({
      next: (statusRes: any) => {
        console.log("Status res", statusRes)
        if (!statusRes || !statusRes.is_integrated) {
          this.isConductIntegrated = false;
          this.conductTimelogs = [];
          this.totalConductWorkedHours = '00:00:00';
          this.isImportingConductTimelogs = false;
          this.cdr.detectChanges();
          return;
        }

        this.isConductIntegrated = true;
        const formattedDate = (this.conductSelectedDate || moment()).format('YYYY-MM-DD');

        this._projectService.getSavedConductTimelogs(companyId, targetUserId, formattedDate).subscribe({
          next: (res: any) => {
            const logs = res?.timelogs || res?.data || (Array.isArray(res) ? res : []);
            let filtered = logs;
            if (logs.some((l: any) => l.supersee_user_id || l.supersee_user)) {
              filtered = logs.filter((log: any) => String(log.supersee_user_id || log.supersee_user) === String(targetUserId));
            }
            this.conductTimelogs = filtered;
            this.calculateConductTotalHours();

            this._projectService.fetchConductTimelogs({ supersee_company_id: companyId, requesting_user_id: targetUserId, start_date: formattedDate, end_date: formattedDate }).subscribe({
              next: (syncRes: any) => {
                this.isImportingConductTimelogs = false;
                const syncLogs = syncRes?.timelogs || syncRes?.data || (Array.isArray(syncRes) ? syncRes : []);
                if (syncLogs && syncLogs.length > 0) {
                  let liveFiltered = syncLogs;
                  if (syncLogs.some((l: any) => l.supersee_user_id || l.supersee_user)) {
                    liveFiltered = syncLogs.filter((log: any) => String(log.supersee_user_id || log.supersee_user) === String(targetUserId));
                  }
                  if (liveFiltered.length > 0) {
                    this.conductTimelogs = liveFiltered;
                    this.calculateConductTotalHours();
                  }
                }
              },
              error: (err: any) => {
                console.error('Error in fetchConductTimelogs background sync:', err);
                this.isImportingConductTimelogs = false;
              }
            });
          },
          error: (err: any) => {
            console.error('Error loading saved Conduct timelogs for employee:', err);
            this._projectService.fetchConductTimelogs({ supersee_company_id: companyId, requesting_user_id: targetUserId, start_date: formattedDate, end_date: formattedDate }).subscribe({
              next: (res: any) => {
                this.isImportingConductTimelogs = false;
                const logs = res?.timelogs || res?.data || (Array.isArray(res) ? res : []);
                let filtered = logs;
                if (logs.some((l: any) => l.supersee_user_id || l.supersee_user)) {
                  filtered = logs.filter((log: any) => String(log.supersee_user_id || log.supersee_user) === String(targetUserId));
                }
                this.conductTimelogs = filtered;
                this.calculateConductTotalHours();
              },
              error: () => {
                this.isImportingConductTimelogs = false;
                this.conductTimelogs = [];
                this.totalConductWorkedHours = '00:00:00';
              }
            });
          }
        });
      },
      error: () => {
        this.isConductIntegrated = false;
        this.conductTimelogs = [];
        this.totalConductWorkedHours = '00:00:00';
        this.isImportingConductTimelogs = false;
        this.cdr.detectChanges();
      }
    });
  }

  calculateConductTotalHours(): void {
    let totalSecs = 0;
    (this.conductTimelogs || []).forEach(log => {
      totalSecs += parseInt(log.duration_time_second, 10) || 0;
    });
    const h = Math.floor(totalSecs / 3600);
    const m = Math.floor((totalSecs % 3600) / 60);
    const s = totalSecs % 60;
    this.totalConductWorkedHours = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  formatLogDuration(seconds: any): string {
    const durSecs = parseInt(seconds, 10) || 0;
    if (durSecs <= 0) return '0s';
    const h = Math.floor(durSecs / 3600);
    const m = Math.floor((durSecs % 3600) / 60);
    const s = durSecs % 60;
    if (h > 0) return `${h}h ${m}m ${s}s`;
    if (m > 0) return `${m}m ${s}s`;
    return `${s}s`;
  }

  updateWeekText(isstack: 'Timeline' | 'Statistics') {
    const isTimeline = isstack === 'Timeline';

    const currentDateOfWeek = isTimeline ? this.stackcurrentDateOfWeek : this.currentDateOfWeek;
    const startOfWeek = new Date(currentDateOfWeek);
    startOfWeek.setDate(currentDateOfWeek.getDate() - currentDateOfWeek.getDay());

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    const startDateString = `${startOfWeek.getDate()} ${this.getMonthName(startOfWeek)} ${startOfWeek.getFullYear()}`;
    const endDateString = `${endOfWeek.getDate()} ${this.getMonthName(endOfWeek)} ${endOfWeek.getFullYear()}`;

    const weekDisplay = `${startOfWeek.getDate()} - ${endDateString}`;
    const weekArray = this.getWeekArray(startDateString, endDateString, isTimeline);
    const startDate = this.datePipe.transform(startOfWeek, "yyyy-MM-dd");
    const endDate = this.datePipe.transform(endOfWeek, "yyyy-MM-dd");

    if (isTimeline) {
      this.stackcurrentWeekDisplay = weekDisplay;
      this.stackcurrentDateOfStart = startOfWeek;
      this.stackcurrentDateofEnd = endOfWeek;
      this.stackcurrentWeekArray = weekArray;
      this.getStackedChartData(startDate, endDate);
    } else {
      this.currentWeekDisplay = weekDisplay;
      this.currentDateOfStart = startOfWeek;
      this.currentDateofEnd = endOfWeek;
      this.currentWeekArray = weekArray;
      this.getBarChartData(startDate, endDate);
    }
  }

  getWeekArray(startDate, endDate, isstack) {
    const weekArray = [];
    const currentDate = new Date(startDate);
    const lastDate = new Date(endDate);

    while (currentDate <= lastDate) {
      weekArray.push(isstack ? this.datePipe.transform(new Date(currentDate), "MMM dd, yyyy") : this.datePipe.transform(new Date(currentDate), "yyyy-MM-dd"));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return weekArray;
  }

  getMonthName(date: Date): string {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNames[date.getMonth()];
  }

  WeekPrevNextAction(prev: boolean, isstack: 'Timeline' | 'Statistics') {
    const isTimeline = isstack === 'Timeline';
    const isStatistics = isstack === 'Statistics';

    if (isTimeline) this._isStackbarLoading = true
    if (isStatistics) this._isUsageLoading = true

    // Clear tooltips when navigating between weeks
    this.clearAllTooltips();

    const dateKey = isTimeline ? 'stackcurrentDateOfWeek' : 'currentDateOfWeek';
    const startDateKey = isTimeline ? 'stackcurrentDateOfStart' : 'currentDateOfStart';

    // Clone the date to avoid modifying the original start date reference
    this[dateKey] = new Date(this[startDateKey]);

    const direction = prev ? -7 : 7;

    this[dateKey].setDate(this[dateKey].getDate() + direction);

    // Validate if at least half of the week (4+ days) falls within the allowed 90-day range
    const minDate = new Date(this.minDateForTimeLine);
    const maxDate = new Date(this.maxDateForTimeLine);

    // Calculate the start and end of the week
    const weekStart = new Date(this[dateKey]);
    weekStart.setDate(this[dateKey].getDate() - this[dateKey].getDay());

    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    // Count how many days in the week fall within the allowed range
    let daysWithinRange = 0;
    const currentDay = new Date(weekStart);

    while (currentDay <= weekEnd) {
      if (currentDay >= minDate && currentDay <= maxDate) {
        daysWithinRange++;
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }

    // If no days are within range, return
    if (daysWithinRange === 0) {
      if (isTimeline) this._isStackbarLoading = false;
      if (isStatistics) this._isUsageLoading = false;
      return;
    }

    this.updateWeekText(isstack);
  }

  getBarChartData(start, end) {
    this.barData = [];
    this.sessionData = []
    this._isUsageLoading = true
    this.totalWorkingHours = [];

    this._projectService.getWorkinHour(start, end, this.userId).subscribe(
      (user: any) => {
        let data;
        let ideal = [];
        let total = [];
        let productive = [];
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        let floatIdealTime = [];
        let floatUsageTime = [];
        let floatOfflineTime = [];
        let label = [];

        this.currentWeekArray.forEach((day) => {
          const date = new Date(day);
          const dayOfWeek = date.getDay();

          const dayName = days[dayOfWeek];
          if (!user[day]) {
            ideal.push('00:00:00');
            this.totalWorkingHours.push(null)
            floatIdealTime.push('00:00:00');
            floatUsageTime.push('00:00:00');
            floatOfflineTime.push('00:00:00');
            total.push('00:00:00');
            label.push(dayName);
          } else {
            label.push(dayName);
            this.totalWorkingHours.push(user[day])
            ideal.push(user[day].idle);
            let idelTime = user[day].idle;
            let productiveTime = user[day].productive;
            let offlineTime = user[day].offline;
            this.barData.push(user[day])
            floatIdealTime.push(this.timeToFloat(idelTime));
            floatUsageTime.push(this.timeToFloat(productiveTime));
            floatOfflineTime.push(this.timeToFloat(offlineTime));
            total.push(user[day].working);
          }
        });

        this.barChartLabels = label;

        this.sessionData = [
          {
            label: "Productive Hours",
            data: floatUsageTime,
            backgroundColor: "#6569D5",
            borderColor: "#ffffff",
            borderWidth: 0,
            maxBarThickness: 42,
            categoryPercentage: 0.72,
            barPercentage: 0.78,
            borderRadius: 6
          },
          {
            label: "Idle Hours",
            data: floatIdealTime,
            backgroundColor: "#C5C7EB",
            borderColor: "#ffffff",
            borderWidth: 0,
            maxBarThickness: 42,
            categoryPercentage: 0.72,
            barPercentage: 0.78,
            borderRadius: 6
          },
          {
            label: "Offline Hours",
            data: floatOfflineTime,
            backgroundColor: "#E0E0E0",
            borderColor: "#ffffff",
            borderWidth: 0,
            maxBarThickness: 42,
            categoryPercentage: 0.72,
            barPercentage: 0.78,
            borderRadius: 6
          }
        ];

        data = {
          idle_time: this.addTimes(ideal) ? this.addTimes(ideal) : "00:00:00",
          productive_time: this.addTimes(productive)
            ? this.addTimes(productive)
            : "00:00:00",
          usage_time: this.addTimes(total) ? this.addTimes(total) : "00:00:00",
        };
        console.warn("BarChartMethod Data : ", data);
        this.donutChartData = data;
        this._isUsageLoading = false;
      },
      (err) => {
        console.error("Error:", err, err.status);
        if (err) {
          this._projectService.updateBarChartData(err);
        }
        if (err.status == 400) {
          this.donutChartData = err.status;
          this.sessionData = [];
          this.barData = [];
        }
        this._isUsageLoading = false;
      }
    );
  }

  async getPieChartData(start, end) {
    this._isAppUsageLoading = true;
    this._projectService.getAppUsageCount(start, end, this.userId).subscribe(async (res) => {
      let data = [];
      let label = [];
      let display = [];
      const chartData = await this.getApplicationUsageData(res)
      chartData.forEach((item) => {
        if (item.appName || item.appName != "") {
          label.push(item.appName);
          data.push(item.usageTime);
          display.push(item);
        }
      })
      this.pieChartData = data;
      this.pieChartLabel = label;
      this.pieChartDisplayData = display;
      this._isAppUsageLoading = false
      if (!data.length) {
        data = undefined;
      }
      if (!label.length) {
        label = undefined;
      }
      if (!display.length) {
        display = undefined;
      }
      this._projectService.updateApplicationUsageData({ data: data, label: label, display: display })
    },
      (err) => {
        this.pieChartData = [];
        this._isAppUsageLoading = false
        this._projectService.updateApplicationUsageData({ data: undefined, label: undefined, display: undefined })
      }
    );
  }

  async getChartDataWebsiteUsage(start, end) {
    this._isWebSiteUsageLoading = true;
    this._projectService.getWebsiteUsageData(start, end, this.userId).subscribe(async (res) => {

      console.log("RESPONSE FROM API IN WEBSITE USAGE", res)
      let data = [];
      let label = [];
      let display = [];
      const chartData = await this.getApplicationUsageData(res);
      chartData.forEach((item) => {
        if (item.appName || item.appName != "") {
          label.push(item.appName);
          data.push(item.usageTime);
          display.push(item);
        }
      })
      this.pieChartData = data;
      this.pieChartLabel = label;
      this.pieChartDisplayData = display;
      this._isWebSiteUsageLoading = false;
      if (!data.length) {
        data = undefined;
      }
      if (!label.length) {
        label = undefined;
      }
      if (!display.length) {
        display = undefined;
      }
      this._projectService.updateWebsiteUsageChart({ data: data, label: label, display: display })
    }, (err) => {
      this.pieChartData = [];
      this._isWebSiteUsageLoading = false
      this._projectService.updateWebsiteUsageChart({ data: undefined, label: undefined, display: undefined })
    });
  }

  async getApplicationUsageData(appUsage) {
    let data = [];
    if (!appUsage) {
      return [];
    }
    for (let key in appUsage) {
      data.push({ appName: key, usageTime: appUsage[key].usageTime != 0 ? appUsage[key].usageTime : '00:00:00', productive_time: appUsage[key].productive_time, idleTime: appUsage[key].idleTime });
    }

    data.sort((a, b) => {
      const timeA = this.parseTime(a.usageTime);
      const timeB = this.parseTime(b.usageTime);
      return timeB - timeA;
    });

    const top10Array = data.slice(0, 10);
    return top10Array
  }

  parseTime(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  makeStackBarChartData(data, min, max) {
    try {
      if (data) {
        this.tempDataTooltip = [];
        this.newSessionTimeline = [];
        this.x_min = min;
        this.x_max = max;
        if (Number(this.x_min) > Number(this.x_max)) {
          this.x_max = 23.59;
        } else {
          if (Number(this.x_max) - Number(this.x_min) < 8.0) {

            if (Number(this.x_min) + 8.0 > 23.59) {
              this.x_max = 23.59;
            } else {
              this.x_max = Number(this.x_min) + 8.0
              this.x_max = Math.ceil(this.x_max)
            }
          } else {
            this.x_max = Math.ceil(this.x_max);
          }
        }
        const newDateLogs = {};
        const dataset = new Map();
        for (const date in data) { // loop dates
          const sessions = this.sortSessionsByStartTime(data[date].sessions); // store sessions for current date
          const chartData = this._sharedService.gettingTheCorrectSession(sessions, 'timeline');
          this.newSessionTimeline.push(sessions)
          this.tempDataTooltip.push(chartData.sessions);
          if (sessions) {
            let sessionLogs = [];
            if (!sessions.length) {
              newDateLogs[date] = sessionLogs;
              continue;
            }
            sessionLogs = processTimelineSessionLogs(sessions);
            newDateLogs[date] = sessionLogs;


          }
        }

        this._sharedService.padArraysToSameLength(newDateLogs, { break: 0, working: 0, label: 'nonusage' });


        Object.values(newDateLogs).forEach((dateSess: any, dateSessIn) => {
          dateSess.forEach((sessLog, sessLogIn) => {
            dataset.set(`${sessLogIn}-nonusage`, {
              data: Array(Object.keys(newDateLogs).length).fill(null),
              label: 'nonusage',
              backgroundColor: colors.timelineStates.nonusage,
              borderColor: 'rgba(255,255,255,0)',
              borderWidth: 0,
              barThickness: 35,
            });

            dataset.set(`${sessLogIn}-idle`, {
              data: Array(Object.keys(newDateLogs).length).fill(null),
              label: 'idle',
              backgroundColor: colors.timelineStates.idle,
              borderColor: 'rgba(255,255,255,0)',
              borderWidth: 0,
              barThickness: 35,
            });

            dataset.set(`${sessLogIn}-usage`, {
              data: Array(Object.keys(newDateLogs).length).fill(null),
              label: 'usage',
              backgroundColor: colors.timelineStates.active,
              borderColor: 'rgba(255,255,255,0)',
              borderWidth: 0,
              barThickness: 35,
            });
          });

        });
        Object.values(newDateLogs).forEach((dateSess: any, dateSessIn) => { // 7 days
          dateSess.forEach((sessLog, sessLogIn) => { // 11 sessions - 3 log types
            const renderLabel = this.getRenderableTimelineLabel(sessLog);
            let existingSessLog = dataset.get(`${sessLogIn}-${renderLabel}`); /** @debug which index should be used? */
            if (existingSessLog) {
              existingSessLog.data[dateSessIn] = sessLog.in
                ? [this._sharedService.formateTimeInDecimal(sessLog.in), this._sharedService.formateTimeInDecimal(sessLog.out)]
                : null;
              dataset.set(`${sessLogIn}-${renderLabel}`, {
                ...existingSessLog,
                ...sessLog,
                label: renderLabel,
                data: existingSessLog.data,
              });
            }
          });
        });
        this._isStackbarLoading = false
        this.stackedChartData = Array.from(dataset.values());
      } else {
        // No Records Found for selected Dates
      }
    } catch (error) {
      // console.error(" ERROR in making stackbar chart data ", error);
    }
  }

  private getRenderableTimelineLabel(sessLog: any): 'nonusage' | 'idle' | 'usage' {
    const originalLabel = sessLog?.label === 'usage' ? 'usage' : (sessLog?.label === 'idle' ? 'idle' : 'nonusage');
    if (originalLabel === 'idle') {
      return 'idle';
    }
    const appName = typeof sessLog?.appName === 'string' ? sessLog.appName.trim() : '';
    const windowName = typeof sessLog?.windowName === 'string' ? sessLog.windowName.trim() : '';
    if (!appName && !windowName) {
      return 'nonusage';
    }
    return originalLabel;
  }

  private sortSessionsByStartTime(sessions: any[]): any[] {
    if (!Array.isArray(sessions)) {
      return [];
    }
    return [...sessions].sort((a: any, b: any) => {
      const aTime = moment(a?.in, 'YYYY-MM-DD HH:mm:ss', true).valueOf();
      const bTime = moment(b?.in, 'YYYY-MM-DD HH:mm:ss', true).valueOf();
      return aTime - bTime;
    });
  }

  getStackedChartData(start: any, endDate: any, days?: any): void {
    this._isStackbarLoading = true
    this.tempDataTooltip = [];
    this.newSessionTimeline = [];
    this.stackedChartlabel = this.stackcurrentWeekArray;

    this._projectService.getUserApplicationLogs(this.userId, start, endDate)
      .subscribe({
        next: (res: any) => this.handleChartDataResponse(res),
        error: () => {
          this._isStackbarLoading = false;
          this.stackedChartData = [{ data: [] }];
          console.error("Failed to fetch application logs");
        }
      });
  }

  private handleChartDataResponse(res: any): void {
    this._isStackbarLoading = false;

    if (!res) {
      console.error("No response for stackbar chart data");
      return;
    }

    const formattedData = this.formatChartData(res);
    const { min, max } = this.extractMinMax(res);

    this.makeStackBarChartData(formattedData, min, max);
  }

  private formatChartData(res: any): Record<string, any> {
    const data: Record<string, any> = {};

    for (const date of this.stackcurrentWeekArray) {
      const dayKey = this.datePipe.transform(new Date(date), "yyyy-MM-dd");
      data[dayKey] = res[dayKey] || { sessions: [] };
    }

    return data;
  }

  private extractMinMax(res: any): { min?: string, max?: string } {
    let min: string | undefined;
    let max: string | undefined;

    if (res.min) {
      min = this.convertTimeToDecimal(res.min);
    }

    if (res.max) {
      max = this.convertTimeToDecimal(res.max);
    }

    return { min, max };
  }

  private convertTimeToDecimal(time: string): string {
    const [hours, minutes] = time.split(":").map(Number);
    return `${this.padZeroes(hours)}.${this.padZeroes(minutes)}`;
  }

  padZeroes(value: number) {
    return value.toString().padStart(2, '0');
  }

  addName(id) {
    if (this.screenCastRequestStatus == true) {
      this.screenCastImage = "data:image/png;base64," + id.image;
    } else {
      this.screenCastImage = null;
    }
  }

  getUserDetails() {
    this._projectService.getEmployeeData(this.userId).subscribe(
      (data: any) => {
        if (!data) {
          data = {
            user: {
              id: this.userId,
            },
            status: "offline",
          };
        }
        this.userDetails = data;
        this.checkIsPersonalize = !this._projectService.isPersonalizeSetting(this.userDetails?.meta?.settings);
        // if (!checkIsPersonalize) {
        //   this.menuItems = this.menuItems.map((menuItem) => {
        //     if (menuItem.id == 'userSettings') {
        //       return {
        //         ...menuItem,
        //         isSvg: true,
        //         icon: this.sanitizer.bypassSecurityTrustHtml(`<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <path
        //           d="M13.5 14.4098C13.5 13.8598 13.95 13.4098 14.5 13.4098C15.05 13.4098 15.5 13.8598 15.5 14.4098C15.5 14.9598 15.05 15.4098 14.5 15.4098C13.95 15.4098 13.5 14.9598 13.5 14.4098ZM11.5 14.4098C11.5 16.0698 12.84 17.4098 14.5 17.4098C16.16 17.4098 17.5 16.0698 17.5 14.4098C17.5 12.7498 16.16 11.4098 14.5 11.4098C12.84 11.4098 11.5 12.7498 11.5 14.4098ZM9.5 5.90984L7.09 4.81984L6 2.40984L4.91 4.81984L2.5 5.90984L4.91 6.99984L6 9.40984L7.09 6.99984L9.5 5.90984ZM13.22 3.12984L11.5 3.90984L13.22 4.68984L14 6.40984L14.78 4.68984L16.5 3.90984L14.78 3.12984L14 1.40984L13.22 3.12984ZM14.5 8.15984C14.38 8.15984 14.25 8.15984 14.13 8.16984L12.66 6.22984L8.33 8.72984L9.27 10.9698C9.14 11.1698 9.01 11.3898 8.9 11.6098L6.5 11.9098L6.5 16.9098L8.91 17.2098C9.02 17.4298 9.15 17.6398 9.28 17.8498L8.33 20.0898L12.66 22.5898L14.13 20.6498C14.25 20.6598 14.38 20.6598 14.5 20.6598C14.62 20.6598 14.75 20.6598 14.87 20.6498L16.34 22.5898L20.67 20.0898L19.73 17.8498C19.86 17.6498 19.99 17.4298 20.1 17.2098L22.5 16.9098L22.5 11.9098L20.09 11.6098C19.98 11.3898 19.86 11.1798 19.72 10.9698L20.66 8.72984L16.33 6.22984L14.86 8.16984C14.75 8.15984 14.62 8.15984 14.5 8.15984ZM18.14 9.57984L17.41 11.3098C18.01 11.8698 18.45 12.6098 18.64 13.4398L20.5 13.6798L20.5 15.1398L18.64 15.3698C18.45 16.1998 18.01 16.9398 17.41 17.4998L18.14 19.2298L16.87 19.9598L15.74 18.4698C15.35 18.5898 14.94 18.6498 14.51 18.6498C14.08 18.6498 13.67 18.5898 13.28 18.4698L12.15 19.9598L10.88 19.2298L11.61 17.4998C11.01 16.9398 10.57 16.1998 10.38 15.3698L8.5 15.1398L8.5 13.6698L10.36 13.4398C10.55 12.6098 10.99 11.8698 11.59 11.3098L10.86 9.57984L12.13 8.84984L13.26 10.3398C13.65 10.2198 14.06 10.1598 14.49 10.1598C14.92 10.1598 15.33 10.2198 15.72 10.3398L16.85 8.84984L18.14 9.57984Z"
        //           fill="#7478D8" />
        //       </svg>`),
        //         matTooltip: 'Personalize Settings',
        //       }
        //     }
        //     return menuItem
        //   })
        // }
        this.loading = false;
      },
      (err) => {
        if (err.status === 403) {
          this._router.navigate(['/employees']);
          this._snackBar.open(err.error.message, 'Undo', {
            duration: 3000
          })
        }
        console.error("ERROR WHILE GET EMPLOYEE DATA");
      }
    );
  }

  onclicktab(select) {
    if (this.ismodelOpen) {
      this.isScreenCast = true;
    }
  }

  selectedTabValue(event) { }

  requestScreenCast(userId) {
    this.openScreencastActionModel();
  }

  requestScreenCastOff(userId) {
    this.screenCastRequestStatus = false;
    this._projectService.screencaseRequestAction(false);
    this._loginService.requestScreenCastOff({ user: userId });
    this.db.database
      .ref(`${this.dbPath}`)
      .child(`${userId}`)
      .update({ scRequestStop: true });
    this.screenCastImage = null;
  }

  openScreencastActionModel() {
    let obj = {
      screenCastImage: this.screenCastImage,
      userDetails: this.userDetails,
      db: this.db,
      dbPath: this.dbPath,
      userId: this.userId,
    };
    let data = obj;

    const dialogRef = this.openDialog(
      ScreencastActionModelComponent,
      data
    ).subscribe((response) => { });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, {
      data,
      panelClass: 'centered-dialog',
    });
    return dialogRef.afterClosed();
  }

  @HostListener("click", ["$event"])
  public onClick(event: any) {
    if (this.isScreenCast == true && event.target.id != "start-SC") {
      if (
        event.target.outerText == "Application Usages" ||
        event.target.outerText == "Screen Shot" ||
        event.target.outerText == "Time logs" ||
        event.target.outerText == "Super\nSee"
      ) {
        this.openScreencastActionModel();
      }
      if (event.target.localName == "li") {
        this.openScreencastActionModel();
      }
    }
  }

  EditUser() {
    this._sharedService.isEdit = true;
    localStorage.setItem("selectedUserId", this.userId);
    this._router.navigate(["/create-user"], {
      queryParams: { groupId: this.userId },
    });
  }

  getAll(): AngularFireList<User> {
    return this.usersRef;
  }

  ngOnDestroy() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    this.entitlementsSub?.unsubscribe();
    this._messagingService.resetData()
  }

  private refreshDownloadSoftwareTypeOptions(): void {
    this.softwareTypeOptions = getSoftwareTypeOptions(
      this.entitlementsService.getPlanCode(),
      this.entitlementsService.isEnforcementActive(),
      this.entitlementsService.hasCompany(EntitlementKey.hidden_mode)
    );
  }

  isDownloadSoftwareTypeLocked(versionType: SoftwareVersionType): boolean {
    return this.softwareTypeOptions.find((option) => option.value === versionType)?.locked ?? false;
  }

  onLockedDownloadSoftwareTypeClick(versionType: SoftwareVersionType): void {
    this.showSoftwareTypeUpgradeDialog(versionType);
  }

  private showSoftwareTypeUpgradeDialog(versionType: string): void {
    const versionTypeError = validateSoftwareVersionType(
      versionType,
      this.entitlementsService.getPlanCode(),
      this.entitlementsService.isEnforcementActive(),
      this.entitlementsService.hasCompany(EntitlementKey.hidden_mode)
    );
    if (!versionTypeError) {
      return;
    }

    const ref = this.dialog.open(PlanUpgradeDialogComponent, {
      width: '420px',
      maxWidth: '94vw',
      data: {
        title: 'Upgrade required',
        message: versionTypeError,
      },
    });
    ref.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        void this._router.navigate(['/billings'], { queryParams: { intent: 'upgrade' } });
      }
    });
  }

  private blockDownloadIfSoftwareTypeLocked(versionType: SoftwareVersionType): boolean {
    const versionTypeError = validateSoftwareVersionType(
      versionType,
      this.entitlementsService.getPlanCode(),
      this.entitlementsService.isEnforcementActive(),
      this.entitlementsService.hasCompany(EntitlementKey.hidden_mode)
    );
    if (versionTypeError) {
      this.showSoftwareTypeUpgradeDialog(versionType);
      return true;
    }
    return false;
  }

  getstatus() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    this.presenceResolved = false;

    // Ensure dbPath exists before proceeding
    if (!this.dbPath) {
      console.warn('Tabs: dbPath not set, cannot initialize Firebase reference');
      this.status = 'not-using';
      this.presenceResolved = true;
      return;
    }

    this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
    this.userDataSubscription = this._messagingService.getUserData().subscribe((users) => {
      let matched = false;
      users.forEach((o) => {
        if (o.id == this.userId) {
          matched = true;
          this.applyPresenceLikeUserList(o);
          this.agentIntegrity = o.agentIntegrity || null;

          if (o.logoutReason) {
            this.logoutReason = {
              ...o.logoutReason,
              time: moment.utc(o.logoutReason?.time).local().format('YYYY-MM-DD HH:mm:ss'),
            };
          }

          if (this.userDetails) {
            this.userDetails = {
              ...this.userDetails,
              status: this.status,
              lastOnlineAtTz: o.lastOnlineAtTz ?? this.userDetails.lastOnlineAtTz,
              lastOnlineAt: o.lastOnlineAt ?? this.userDetails.lastOnlineAt,
            };
          }

          if (o && o.appInfo && o.osInfo) {
            this.currentApplicationInformation = o.appInfo
            this.currentOSInformation = o.osInfo
            let menuItemAppInfos = {
              menus: [
                {
                  value: o.appInfo?.version ? 'v-' + o.appInfo.version : 'N/A',
                  icon: 'release_alert',
                  tooltip: 'Version'
                },
                {
                  value: this.getAgentInfo(o),
                  icon: this.getAgentInfo(o, true),
                  tooltip: 'Mode'
                },
                {
                  value: this.getOSInfo(o.osInfo),
                  icon: this.getOSIconInforAndGiveImage(o.osInfo.os),
                  image: true,
                  tooltip: 'OS'
                }
              ]
            };
            this.menuItems = this.menuItems.map(menuItem => {
              if (menuItem.id && menuItem.id == "appInfo") {
                menuItem.submenu = menuItemAppInfos;
              }
              return menuItem;
            });
          }
        }
      });
      if (!matched) {
        this.status = 'not-using';
      }
      this.presenceResolved = true;
    });

    let roleArr = [];
    this._projectService.getUser().subscribe((data: any) => {
      roleArr = data.role;
      let adminRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
      })
      if (adminRole.length == 0) {
        this.isAdmin = false;
      } else {
        this.isAdmin = true;
      }

      let managerRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("manager"));
      })
      if (managerRole.length == 0) {
        this.isManager = false;
      } else {
        this.isManager = true;
      }

      let leadRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("lead"));
      })
      if (leadRole.length == 0) {
        this.isTeamLead = false;
      } else {
        this.isTeamLead = true;
      }
    })
  }

  screenshotRequest() {
    if (this.status == "online" || this.status == "idle") {
      if (!this._sharedService.canTriggerScreenshotRequest(this.userId)) {
        return;
      }
      let data = {
        type: "Requesting Screenshot",
        userName: this.userDetails.name
      };
      this._sharedService.showToast(data);
      setTimeout(() => {
        this.db.database.ref(`${this.dbPath}`).child(`${this.userId}`).get().then((res) => {
          if (res.val().ssRequest == null) {
            this.db.database
              .ref(`${this.dbPath}`)
              .child(`${this.userId}`)
              .update({ ssRequest: false });
            let data = {
              type: "Cant get screenshot",
              userName: this.userDetails.name,
            };
            this._sharedService.showToast(data);
          }
        });
      }, 20000)

      this._sharedService.startOnDemandScreenshotRequest({
        employeeId: this.userId,
        dbPath: this.dbPath,
        source: 'tabs',
      });
    }
  }

  convertTimeIntoFloat(time) {
    const [hours, minutes] = time.split(":").map(Number);
    const floatingValue = parseFloat(
      `${hours == "00" ? "24" : hours}.${minutes}`
    ).toFixed(2);
    return floatingValue;
  }

  addTimes(timeArr) {
    const totalMilliseconds = timeArr
      .map((timeStr) => {
        const timeParts = timeStr.split(":");
        return (
          parseInt(timeParts[0]) * 3600000 +
          parseInt(timeParts[1]) * 60000 +
          parseInt(timeParts[2]) * 1000
        );
      })
      .reduce((acc, curr) => acc + curr, 0);

    const hours = Math.floor(totalMilliseconds / 3600000);
    const minutes = Math.floor((totalMilliseconds % 3600000) / 60000);
    const seconds = Math.floor((totalMilliseconds % 60000) / 1000);

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  timeToFloat(time: any) {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    const totalTimeInSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalTimeInSeconds / 3600;
  }

  onStartDateChange(event) {
    let date = event.value;
    this.startDate = this.datePipe.transform(date, "yyyy-MM-dd");
  }

  onEndDateChange(event) {
    let date = event.value;
    this.workingHours = null;
    if (this.startDate) {
      this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    }

    this.endDate = this.datePipe.transform(date, "yyyy-MM-dd");

    if (this.startDate && this.endDate) {
      this.sendingStartDate = this.startDate;
      this.sendingEndDate = this.endDate;
      this.getPieChartData(this.startDate, this.endDate);
    }
  }

  onStartDateChangeWebsiteChart(event: any) {
    let date = event.value;
    this.startDateForWebUsageChart = this.datePipe.transform(date, "yyyy-MM-dd");
  }

  onEndDateChangeWebsiteChart(event: any) {
    let date = event.value;
    this.workingHours = null;
    if (this.startDateForWebUsageChart) {
      this.startDateForWebUsageChart = this.datePipe.transform(this.startDateForWebUsageChart, "yyyy-MM-dd");
    }

    this.endDateForWebUsageChart = this.datePipe.transform(date, "yyyy-MM-dd");
    if (this.startDateForWebUsageChart && this.endDateForWebUsageChart) {
      this.getChartDataWebsiteUsage(this.startDateForWebUsageChart, this.endDateForWebUsageChart);
    }
  }

  gettingDataFilter(data) {
    let logsArr = [];
    let applicationNames = [];
    for (let key in data) {
      data[key].logs.map((ele) => {
        logsArr.push(ele);
      });
    }
    for (let key in data) {
      applicationNames.push(key);
    }
    return { logs: logsArr, apps: applicationNames };
  }

  timeToNumber(timeString) {
    var timeParts = timeString.split(":");
    var hours = parseInt(timeParts[0]);
    var minutes = parseInt(timeParts[1]);

    var decimalValue = hours + minutes / 60;

    decimalValue = Math.round(decimalValue * 100) / 100;
    return decimalValue;
  }

  getUserCurrentStatus(lastActiveTime: any, isUtCTimeZone: any) {
    if (isUtCTimeZone) {
      this.status = lastActiveTime ? this._sharedService.getUserCurrentStatus(lastActiveTime, true) : 'not-using';
    } else {
      this.status = lastActiveTime ? this._sharedService.getUserCurrentStatus(lastActiveTime, false) : 'not-using';
    }
    return this.status
  }

  getWeek(e) {
    if (e == 0) {
      this.currentDate = moment();
    } else {
      this.currentDate.add(e, 'weeks');
    }

    let weekStart = this.currentDate.clone().startOf('week');
    let weekEnd = this.currentDate.clone().endOf('week');
    let days = [];
    let now = weekStart.clone()
    while (now.isSameOrBefore(weekEnd)) {
      days.push([now.format('dddd'), now.format('YYYY-MM-DD')]);
      now = now.add(1, 'days');
    }
  }

  trimName(name) {
    if (name) {
      const trimmedName = name.length <= 20 ? name : name.slice(0, 20) + (name.length > 20 ? '...' : '');
      return trimmedName;
    }
  }

  checkLogoutReason(logoutTime: string, lastActiveTime: string) {
    // Keep logic aligned with employee list (user-list.component.ts) for consistent status.
    return moment(logoutTime).isSameOrAfter(moment(lastActiveTime));
  }

  /**
   * Mirrors `UserListComponent.updateUserStatus` (user-list.component.ts) for one Firebase user row.
   */
  private applyPresenceLikeUserList(user: any): void {
    this.lastActiveTime = null;
    this.lastActiveTimeTz = null;
    this.idleStartTimeRaw = null;
    this.lastOnlineAtTzRaw = user?.lastOnlineAtTz ?? null;
    this.lastOnlineAtRaw = user?.lastOnlineAt ?? null;

    const isLogoutReason = this.checkLogoutReason(user.logoutReason?.time, user.lastOnlineAtTz);

    if (user.logoutReason && isLogoutReason) {
      this.status = 'auto-logout';
      if (user.logoutReason?.reason === 'timeOrTimezoneChange') {
        this.logoutReason = {
          reason: 'Time or Timezone Changed.',
          time: moment.utc(user.logoutReason?.time).local().format('YYYY-MM-DD HH:mm:ss'),
        };
      }
    } else if (user.isIdle === true) {
      if (this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) == 'online') {
        this.status = 'idle';
        if (user.idleStartTime) {
          this.idleStartTimeRaw = user.idleStartTime;
        }
      } else if (this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) != 'online') {
        this.status = this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true);
      }
    } else if (user.lastOnlineAtTz) {
      this.lastActiveTimeTz = this.customtimeAgoPipe.transform(user.lastOnlineAtTz, 'lastActive');
      this.status = this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true);
    } else if (!user.lastOnlineAtTz && user.lastOnlineAt) {
      this.lastActiveTime = this.customtimeAgoPipe.transform(user.lastOnlineAt);
      this.status = this._sharedService.getUserCurrentStatus(user.lastOnlineAt, false);
    } else {
      this.status = 'not-using';
    }
  }

  /** Same classification as `UsersTableComponent.getUserStatusType` (used by user-list table). */
  getProfileStatusType(): string {
    if (!this.presenceResolved) {
      return 'none';
    }
    const user = { status: this.status, logoutReason: this.logoutReason };
    if (user.status === 'auto-logout') {
      return 'auto-logout';
    }
    if (user.status === 'idle') {
      return 'idle';
    }
    if (user.status === 'online') {
      return 'online';
    }
    if (!user.status || user.status === 'not-using') {
      return 'invited';
    }
    if (
      user.status !== 'online' &&
      user.status !== 'not-using' &&
      user.status !== 'auto-logout' &&
      user.status !== 'idle'
    ) {
      const checkLastOnlineAtTime = this._sharedService.getDayDifferenceForAbsent(user.status);
      if (checkLastOnlineAtTime > 0) {
        return 'absent';
      }
      return 'offline';
    }
    return 'none';
  }

  getProfileAutoLogoutTooltip(): string {
    return `${this.logoutReason?.reason} Time: ${this.logoutReason?.time}`;
  }

  getProfileOfflineTooltip(): string {
    if (this.lastOnlineAtTzRaw) {
      return `Last active at ${this.customtimeAgoPipe.transform(this.lastOnlineAtTzRaw, 'lastActive')}`;
    }
    if (this.lastOnlineAtRaw) {
      return `Last active at ${this.customtimeAgoPipe.transform(this.lastOnlineAtRaw)}`;
    }
    return `Last active at ${this.customtimeAgoPipe.transform(this.status, 'lastActive')}`;
  }

  getSignedOutLabel(): string {
    return getSignedOutLabelForUser(this.userDetails, this.getProfileStatusType());
  }

  getPasswordResetLabel(): string {
    return getPasswordResetLabelForUser(this.userDetails, this.getProfileStatusType());
  }

  getProfileIdleTooltip(): string {
    if (this.idleStartTimeRaw) {
      return `Idle since ${this.customtimeAgoPipe.transform(this.idleStartTimeRaw, 'lastActive')}`;
    }
    return 'Idle';
  }

  /** Screenshot / screencast enabled like users-table (online or idle string only). */
  isProfilePresenceActionEnabled(): boolean {
    return this.status === 'online' || this.status === 'idle';
  }

  openModalFire(id: any) {
    if (this._modalService.isAlreadyOpenDialog(CreateUserComponent)) {
      this._modalService.closeDialogIfOpen(CreateUserComponent);
    }
    const dialogRef = this._modalService.openCommonMatDialog(
      CreateUserComponent,
      {
        className: 'create-user-modal',
        maxHeight: '80vh',
        disableClose: false,
        componentData: { isUserEditable: true, editUserId: id, fromProfileScreen: true },
        // position: { top: '30px' }
      }
    );

    // Subscribe to modal close to refresh user data if update was successful
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.updated) {
        // Refresh user details after successful update
        this.getUserDetails();
      }
    });
  }

  resetPassword(user: any) {

    const dialogData = {
      id: user.id,
      email: user.email
    }

    this.dialog.open(NewPasswordComponent, {
      width: '660px',
      data: dialogData,
      panelClass: 'centered-dialog',
    })
  }

  openPasswordResets(user: any) {
    this.dialog.open(PasswordResetsDialogComponent, {
      width: '420px',
      data: {
        userId: user?.id,
        employeeName: user?.name || '',
      },
      panelClass: 'centered-dialog',
    });
  }

  deleteUser(id, dev) {
    let data = {
      id: id,
      name: dev.name,
      type: "employee"
    };

    this.openActionDialog(ConfirmationDialogComponent, data).subscribe((response) => {
      if (response != undefined) {
        // Use showCustomAlert for pre-deletion message with timer
        this.sweetAlertService.showCustomAlert({
          title: 'Deleting Employee',
          text: `${dev.name} will be deleted shortly.`,
          icon: 'info',
          timer: 3000, // Auto-close after 3 seconds
          showConfirmButton: false // Hide the OK button
        });

        this._projectService
          .DeleteEmployee(response.delete)
          .subscribe((data: any) => {
            // Show success message and redirect to employees list after successful deletion
            this.sweetAlertService.showCustomAlert({
              title: 'Success!',
              text: 'Employee deleted successfully',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });

            // Redirect after a short delay to allow the success message to be visible
            setTimeout(() => {
              this._router.navigate(['/employees']);
            }, 2500);
          });
      }
    });
  }

  openActionDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, {
      data,
      panelClass: 'centered-dialog',
    });
    return dialogRef.afterClosed();
  }

  navigateToSettings() {
    this._router.navigate(['/employee/setting/', this.userId]);
  }

  navigateToTimeSheet() {
    this._router.navigate(['/user-report/', this.userId]);
  }


  isLogoutHealthEntry(entry: any): boolean {
    if (!entry) return false;
    const state = (entry?.state || '').toUpperCase();
    if (state === 'LOGOUT' || state === 'LOGGED_OUT') return true;

    const rawCodes = this.getReasonCodes(entry?.reasonCode || entry?.reason);
    if (rawCodes.length === 0) return false;

    return rawCodes.every(c => {
      const upper = c.toUpperCase();
      return upper === 'ERR_USER_LOGGED_OUT' || upper === 'USER LOGGED OUT';
    });
  }

  getHealthItemState(item: any): string {
    if (!item) return 'UNKNOWN';
    if (this.isLogoutHealthEntry(item)) return 'LOGOUT';
    return (item.state || 'UNKNOWN').toUpperCase();
  }

  getUserHealthState(): 'HEALTHY' | 'UNHEALTHY' | 'STARTING' | 'UNINSTALLED' | 'LOGOUT' | 'UNKNOWN' {
    const history = this.agentIntegrity?.healthHistory || this.userDetails?.agentIntegrity?.healthHistory;
    if (Array.isArray(history) && history.length > 0) {
      const latest = history[history.length - 1];
      if (this.isLogoutHealthEntry(latest)) return 'LOGOUT';
      const state = (latest?.state || '').toUpperCase();
      if (state === 'HEALTHY') return 'HEALTHY';
      if (state === 'UNHEALTHY') return 'UNHEALTHY';
      if (state === 'STARTING') return 'STARTING';
      if (state === 'UNINSTALLED') return 'UNINSTALLED';
      if (state === 'LOGOUT' || state === 'LOGGED_OUT') return 'LOGOUT';
    }
    if (this.userDetails?.uninstall?.isUninstalled) return 'UNINSTALLED';
    return 'UNKNOWN';
  }

  getLatestHealthEntry(): any {
    const history = this.agentIntegrity?.healthHistory || this.userDetails?.agentIntegrity?.healthHistory;
    if (Array.isArray(history) && history.length > 0) {
      return history[history.length - 1];
    }
    return null;
  }

  getHealthHistory(): any[] {
    const history = this.agentIntegrity?.healthHistory || this.userDetails?.agentIntegrity?.healthHistory;
    if (Array.isArray(history)) {
      return [...history].reverse();
    }
    return [];
  }

  getReasonCodes(reasonCode?: string): string[] {
    return this._sharedService.getReasonCodes(reasonCode);
  }

  getSingleComponent(component: string): string {
    return this._sharedService.getSingleComponent(component);
  }

  getHumanReadableComponent(component?: string): string {
    return this._sharedService.getHumanReadableComponent(component);
  }

  getSingleReason(code: string): string {
    return this._sharedService.getSingleReason(code);
  }

  getHumanReadableReasonList(reasonCode?: string): string[] {
    return this._sharedService.getHumanReadableReasonList(reasonCode);
  }

  getReasonCodeByIndex(reasonCode?: string, index: number = 0): string {
    return this._sharedService.getReasonCodeByIndex(reasonCode, index);
  }

  getReasonFix(code: string): string {
    return this._sharedService.getReasonFix(code);
  }

  expandedFixKeys: { [key: string]: boolean } = {};

  toggleFixAccordion(key: string): void {
    this.expandedFixKeys[key] = !this.expandedFixKeys[key];
  }

  isFixExpanded(key: string): boolean {
    return !!this.expandedFixKeys[key];
  }

  isAnyActiveFixExpanded(): boolean {
    return Object.keys(this.expandedFixKeys).some(k => k.startsWith('active_') && !!this.expandedFixKeys[k]);
  }

  getReasonFixSteps(code: string): string[] {
    return this._sharedService.getReasonFixSteps(code);
  }

  getHumanReadableReason(reasonCode?: string): string {
    return this._sharedService.getHumanReadableReason(reasonCode);
  }

  formatHealthTimestamp(utcTimestamp?: string, format: string = 'MMM D, YYYY h:mm:ss A'): string {
    return this._sharedService.formatHealthTimestamp(utcTimestamp, format);
  }

  getHealthRelativeTime(utcTimestamp?: string): string {
    return this._sharedService.getHealthRelativeTime(utcTimestamp);
  }

  getHealthStatusIcon(): string {
    const state = this.getUserHealthState();
    if (state === 'UNHEALTHY') return 'error';
    if (state === 'UNINSTALLED') return 'cancel';
    if (state === 'LOGOUT') return 'logout';
    if (state === 'HEALTHY') return 'check_circle';
    if (state === 'STARTING') return 'sync';
    return 'info';
  }

  getHealthStatusLabel(): string {
    const state = this.getUserHealthState();
    if (state === 'UNHEALTHY') return 'Agent Unhealthy';
    if (state === 'UNINSTALLED') return 'Agent Uninstalled';
    if (state === 'LOGOUT') return 'User Logout';
    if (state === 'HEALTHY') return 'Agent Healthy';
    if (state === 'STARTING') return 'Agent Starting';
    return 'Agent Unknown';
  }

  getHealthStatusColorClass(): string {
    const state = this.getUserHealthState();
    if (state === 'HEALTHY') return 'text-emerald-600';
    if (state === 'STARTING') return 'text-blue-600';
    if (state === 'UNHEALTHY' || state === 'UNINSTALLED' || state === 'LOGOUT') return 'text-red-600';
    return 'text-gray-600';
  }

  isOutdatedVersion(appInfo: any): boolean {
    return this.isCriticallyOutdated(appInfo) || this.isWarningVersion(appInfo);
  }

  isMenuTooltip: boolean = false;

  showHealthTooltip(event: MouseEvent): void {
    this.expandedFixKeys = {};
    if (this.healthTooltipTimeout) {
      clearTimeout(this.healthTooltipTimeout);
      this.healthTooltipTimeout = null;
    }
    this.showHealthTooltipCard = true;

    const target = event.currentTarget as HTMLElement;
    const isInMenu = !!target.closest('.mat-menu-panel, .more-button-dropdowns');
    this.isMenuTooltip = isInMenu;
    const rect = target.getBoundingClientRect();
    const tooltipWidth = 360;

    const historyCount = this.getHealthHistory()?.length || 1;
    const isUnhealthy = this.getUserHealthState() === 'UNHEALTHY';
    const estimatedHeight = Math.min(320, 95 + (isUnhealthy ? 70 : 0) + Math.min(historyCount, 3) * 45);

    let left: number;
    let top: number;

    if (isInMenu && rect.left - tooltipWidth - 12 >= 10) {
      // Place to the left of the dropdown menu
      left = rect.left - tooltipWidth - 12;
      top = rect.top - 20;
      if (top + estimatedHeight > window.innerHeight - 15) {
        top = Math.max(10, window.innerHeight - estimatedHeight - 15);
      }
      if (top < 10) {
        top = 10;
      }
    } else {
      left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
      if (left + tooltipWidth > window.innerWidth - 20) {
        left = window.innerWidth - tooltipWidth - 20;
      }
      if (left < 20) {
        left = 20;
      }

      top = rect.bottom + 8;
      if (top + estimatedHeight > window.innerHeight - 15) {
        top = Math.max(10, rect.top - estimatedHeight - 8);
      }
    }

    this.healthTooltipPosition = { top, left };

    setTimeout(() => {
      if (!this.showHealthTooltipCard) return;
      const card = document.querySelector('.health-tooltip-card') as HTMLElement;
      if (card && card.offsetHeight > 0) {
        const actualH = card.offsetHeight;
        if (isInMenu && rect.left - tooltipWidth - 12 >= 10) {
          let newTop = rect.top - 20;
          if (newTop + actualH > window.innerHeight - 15) {
            newTop = Math.max(10, window.innerHeight - actualH - 15);
          }
          if (newTop < 10) {
            newTop = 10;
          }
          this.healthTooltipPosition = { top: newTop, left };
        } else {
          let newTop = rect.bottom + 8;
          if (newTop + actualH > window.innerHeight - 15) {
            newTop = Math.max(10, rect.top - actualH - 8);
          }
          this.healthTooltipPosition = { top: newTop, left };
        }
      }
    }, 0);
  }

  hideHealthTooltip(): void {
    this.healthTooltipTimeout = setTimeout(() => {
      if (!this.healthTooltipHovered) {
        this.clearHealthTooltip();
      }
    }, 200);
  }

  clearHealthTooltip(): void {
    if (this.healthTooltipTimeout) {
      clearTimeout(this.healthTooltipTimeout);
      this.healthTooltipTimeout = null;
    }
    this.showHealthTooltipCard = false;
    this.healthTooltipHovered = false;
    this.expandedFixKeys = {};
    this.isMenuTooltip = false;
  }

  clearAllTooltips() {
    // Clear timeline chart tooltips
    const tooltipBarChart = document.getElementById('tooltipBarChart');
    if (tooltipBarChart) {
      tooltipBarChart.style.display = 'none';
    }

    const appUsageTooltip = document.getElementById('app_usage_tooltip_horizontal');
    if (appUsageTooltip) {
      appUsageTooltip.style.display = 'none';
    }

    // Clear any other tooltips that might be visible
    const chartTooltip = document.getElementById('chartjs-tooltip');
    if (chartTooltip) {
      chartTooltip.style.opacity = '0';
    }
  }

  setTimeRangeForDateInputs() {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id ?? user?.company_id;
    const dateToUse = user?.meta?.today_date || new Date();

    this._sharedService.getValidationDateRangeByCompany(dateToUse, companyId).subscribe((range) => {
      this.maxApplicationUsageDate = range.maxDate;
      this.maxWebsiteUsageDate = range.maxDate;
      this.maxDateForTimeLine = range.maxDate;
      this.minApplicationUsageDate = range.minDate;
      this.minWebsiteUsageDate = range.minDate;
      this.minDateForTimeLine = range.minDate;
    });
  }
  getAgentInfo(user: any, isForIcon: boolean = false): string {
    const label = user.appInfo?.applicationType?.split("")[0].toUpperCase();
    const settings = this.userDetails?.meta?.settings;

    if (label === 'S') {
      return isForIcon ? 'visibility_off' : 'Hidden';
    }

    if (label === 'G') {
      if (settings?.ss_personalizeSettings === 'true') {
        return settings.ss_automatic_tracking === 'true' ? isForIcon ? 'admin_panel_settings' : 'Admin Controlled' : isForIcon ? 'person_outline' : 'Employee Controlled';
      } else if (settings?.ss_personalizeSettings === 'false') {
        return this.globalSettings?.ss_automatic_tracking === 'true' ? isForIcon ? 'admin_panel_settings' : 'Admin Controlled' : isForIcon ? 'person_outline' : 'Employee Controlled';
      }
      return isForIcon ? 'person_outline' : 'Employee Controlled';
    }

    return 'N/A';
  }

  getOSInfo(osInfo) {

    const { os: platform, release } = osInfo;

    if (platform === 'win32') {
      const build = parseInt(release.split('.')[2], 10);
      if (release.startsWith('6.1')) return 'Windows 7';
      if (release.startsWith('6.2')) return 'Windows 8';
      if (release.startsWith('6.3')) return 'Windows 8.1';
      if (release.startsWith('10.0')) {
        return build >= 22000 ? 'Windows 11' : 'Windows 10';
      }
      return 'Unknown Windows version';
    }

    if (platform === 'darwin') {
      const darwinMajor = parseInt(release.split('.')[0], 10);
      const macOsRelease: any = this.sysConfig.macOsRelease
      const macOSVersionMap = new Map(macOsRelease);
      return macOSVersionMap.get(darwinMajor) || `Unknown macOS (Darwin ${darwinMajor})`;
    }

    if (platform === 'linux') {
      return 'Ubuntu';
    }

    return 'Unknown OS';
  }

  getOSIconInforAndGiveImage(os: string): string {
    const baseUrl = 'https://us.aptabase.com/assets/';

    switch (os) {
      case 'win32':
        return `${baseUrl}windows-cfcb5d46.svg`;
      case 'linux':
        return `${baseUrl}ubuntu-9a344cb4.svg`;
      case 'darwin':
        return `${baseUrl}macos-e20f2458.svg`;
      default:
        return '';
    }
  }

  downloadGeneralAgent(lable: any) {
    this._projectService.downloadGeneralAgent(lable)
  }

  downloadRustGeneralAgent(): void {
    if (this.userDetails?.id) {
      this._projectService.applyEmployeeControlAndDownloadRust('Windows', this.userDetails);
      return;
    }
    this._projectService.downloadRustGeneralAgent();
  }

  autoResetPasswordRust(label: string, user: any): void {
    if (this.blockDownloadIfSoftwareTypeLocked('silent')) {
      return;
    }
    this._projectService.autoResetPasswordRust(label, user);
  }

  downloadRustAdminControlAgent(osLabel: string, user: any): void {
    if (this.blockDownloadIfSoftwareTypeLocked('restricted')) {
      return;
    }

    const isCompanySettings = this._projectService.isPersonalizeSetting(user?.meta?.settings);
    const dialogRef = this.dialog.open(AdminControlConfirmDialogComponent, {
      width: '460px',
      disableClose: true,
      panelClass: 'centered-dialog',
      data: installerConfirmCopy.adminControlled(
        resolveEmployeeFirstName(user),
        isCompanySettings,
        isInstallerFirstTimeEmployee(user)
      ),
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.confirmed) {
        this._projectService.applyAdminControlAndDownloadRust(osLabel, user);
      }
    });
  }

  autoResetPassword(lable, user) {
    if (this.blockDownloadIfSoftwareTypeLocked('silent')) {
      return;
    }
    this._projectService.autoResetPassword(lable, user);
  }

  downloadAdminControlAgent(osLabel: string, user: any) {
    if (this.blockDownloadIfSoftwareTypeLocked('restricted')) {
      return;
    }

    const isCompanySettings = this._projectService.isPersonalizeSetting(user?.meta?.settings);
    const dialogRef = this.dialog.open(AdminControlConfirmDialogComponent, {
      width: '460px',
      disableClose: true,
      panelClass: 'centered-dialog',
      data: installerConfirmCopy.adminControlled(
        resolveEmployeeFirstName(user),
        isCompanySettings,
        isInstallerFirstTimeEmployee(user)
      ),
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) { return; }
      if (result.confirmed) { this._projectService.applyAdminControlAndDownload(osLabel, user); }
    });
  }

  isCriticallyOutdated(appInfo: any): boolean {
    if (!appInfo?.version) {
      return false;
    }
    return this._projectService.getVersionState(appInfo.version, this.currentOSInformation)
      === this._projectService.VERSION_CASES.CRITICAL;
  }

  getVersionWarningTooltip(appInfo: any): string {
    const currentVersion = appInfo?.version || 'Unknown';
    const versionTargets = this._projectService.getVersionTargetsByOs(this.currentOSInformation);
    return `Please update to v-${versionTargets.latest}. You are using v-${currentVersion} which is outdated.`;
  }

  isWarningVersion(appInfo: any): boolean {
    if (!appInfo?.version) {
      return false;
    }
    return this._projectService.getVersionState(appInfo.version, this.currentOSInformation)
      === this._projectService.VERSION_CASES.WARNING;
  }

}
